<template>
    <div id="novel_info">
        <div class="novel_success1 cursor_1" @click="toNovellist">
            <img src="../assets/image/icon_right.png" alt="">
            作品信息
        </div>
        <div class="novel_info">
            <div class="novel_info1">
                <div class="novel_info1_1">
                    <img :src="novelInfo.img" alt="">
                </div>
                <!-- <div class="novel_info1_2 cursor_1" >
                    <span @click="openCover">更换封面</span>
                    <span class="t-p-l-10" @click="downloadImg">图片下载</span>
                </div> -->
                <div class="novel_info1_2 cursor_1" @click="openCover">
                    <span>更换封面</span>
                </div>
            </div>
            <div class="novel_info2">
                <div class="novel_info2_15">
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            书号
                        </div>
                        <div class="novel_info2_3">
                            {{ novelInfo.id }}
                        </div>
                    </div>
                    <!-- 作品名称 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>作品名称
                        </div>
                        <div class="novel_info2_3">
                            <el-input v-model="novelInfo.name" ref="nxszpm" :maxlength="150" show-word-limit
                                placeholder="请输入作品名称"></el-input>
                            <div class="novel_info2_14 cursor_1" @click="openPopup('作品名称', 0)"></div>
                            <div class="loading_text" v-if="streamStatus && requireIndex == 0">
                                <img src="../assets/image/loading.png" alt="">
                            </div>
                        </div>
                    </div>
                    <!-- 核心受众 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>核心受众
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_4" v-for="(item, i) in sex" :key="i"
                                @click.stop="getSex(item.value)">
                                <img :src="novelInfo.novelSex === item.value ? iconSelect[1] : iconSelect[0]" alt="">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                    <!-- 作品类型 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>小说题材
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_6 cursor_1" v-if="novelInfo.typeName" @click="openLabel3">
                                {{ novelInfo.typeName }}
                                <img :src="iconSelect[4]" @click.stop="delLabel(0, '类型')" alt="">
                            </div>
                            <div v-if="!novelInfo.typeName" class="novel_info2_7 cursor_1" @click="openLabel3">
                                <img :src="iconSelect[3]" alt="">
                                {{ novelInfo.typeName ? '更换题材' : '添加题材' }}
                            </div>
                        </div>
                        <!-- <div class="novel_info2_3" :class="isEditor() ? 'noClick' : ''">
                            <el-cascader v-model="novelInfo.typeName" :options="options"
                                :props="{ expandTrigger: 'hover' }" @change="getTypeName"
                                placeholder="请选择作品类型"></el-cascader>
                        </div> -->
                    </div>
                    <!-- 作品标签 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>小说标签
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_5">
                                <div class="novel_info2_6 cursor_1" v-for="(item, i) in novelInfo.labels" :key="i"
                                    @click="openLabel">
                                    {{ item }}
                                    <img :src="iconSelect[4]" @click.stop="delLabel(i, '标签')" alt="">
                                </div>
                                <div v-if="novelInfo.labels.length < 20" class="novel_info2_7 cursor_1"
                                    @click="openLabel">
                                    <img :src="iconSelect[3]" alt="">
                                    添加标签
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- 文笔风格 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>文笔风格
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_5">
                                <div class="novel_info2_6 cursor_1" v-for="(item, i) in novelInfo.style" :key="i"
                                    @click="openLabel2">
                                    {{ item }}
                                    <img :src="iconSelect[4]" @click.stop="delLabel(i, '风格')" alt="">
                                </div>
                                <div v-if="novelInfo.style.length < 10" class="novel_info2_7 cursor_1"
                                    @click="openLabel2">
                                    <img :src="iconSelect[3]" alt="">
                                    添加标签
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- 写作视角 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>写作视角
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_4" v-for="(item, i) in viewList" @click="getview(item)" :key="i">
                                <img :src="novelInfo.view === item ? iconSelect[2] : iconSelect[0]" alt="">
                                {{ item }}
                            </div>
                        </div>
                    </div>

                    <!-- 篇幅设定 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>篇幅设定
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_4" v-for="(item, i) in lengthList" @click="getLength(item)" :key="i">
                                <img :src="novelInfo.length.includes(item) ? iconSelect[2] : iconSelect[0]" alt="">
                                {{ item }}
                            </div>
                        </div>
                    </div>
                    <!-- 总章节数 -->
                    <div class="novel_info2_1" v-if="novelInfo.length.includes('长篇')">
                        <div class="novel_info2_2">
                            <span>*</span>总章节数
                        </div>
                        <div class="novel_info2_3">
                            <el-input :disabled="novelInfo.thereAnOutline && !isCopy" v-model="novelInfo.maxChapter" type="number"
                                :placeholder="'章节数小于' + maxChapterLen"></el-input>
                        </div>
                    </div>
                    <!-- 首次生成章节 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2" v-if="novelInfo.length.includes('长篇')">
                            <span>*</span>{{ !novelInfo?.thereAnOutline ? '首次生成章节' : '当前生成章节' }}
                        </div>
                        <div class="novel_info2_2" v-else>
                            <span>*</span>{{ !novelInfo?.thereAnOutline ? '首次生成章节' : '当前生成章节' }}
                        </div>
                        <div class="novel_info2_3">
                            <el-input :disabled="novelInfo.thereAnOutline && !isCopy" v-model="novelInfo.chaptersNumber"
                                type="number"
                                :placeholder="novelInfo.length.includes('长篇') ? `请输入生成章节1~${chaptersNumberLen}` : `请输入生成章节1~${shortStoryLen}`"></el-input>
                        </div>
                    </div>
                    <!-- 长记忆功能 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2"> <span>*</span>长记忆
                            <!-- <el-tooltip class="item" effect="dark" placement="top">
                                <div slot="content">
                                    <span>普通会员、基础会员无法使用该功能</span>
                                </div>
                                <svg-icon iconClass="vip" class="custom" style="font-size: 22px;color: #FF8802;" />
                            </el-tooltip> -->
                        </div>
                        <div class="flex-row">
                            <div class="flex-row t-m-r-10">
                                <img src="@/assets/image/vip/icon6.png" width="21" height="19" />
                                <span class="t-m-l-2">专业会员专享</span>
                            </div>
                            <el-switch class="t-m-r-10" @change="cjyChange" :disabled="isCopy ? false : true"
                                v-model="novelInfo.recall"></el-switch>
                        </div>
                    </div>
                    <!-- 作品状态 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            作品状态
                        </div>
                        <div class="novel_info2_3">
                            <span>
                                {{ novelStatus[novelInfo.status] }}
                            </span>
                            <!-- <div class="novel_info2_4" v-for="(item, i) in novelStatus" :key="i" @click="getStatus(i)">
                                <img :src="novelInfo.status == i ? iconSelect[1] : iconSelect[0]" alt="">
                                {{ item }}
                            </div> -->
                        </div>
                    </div>
                    <!-- 世界观 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            世界观<span>(非必填)</span>
                        </div>
                        <div class="novel_info2_3">
                            <el-input v-model="novelInfo.world" type="textarea" ref="world" :maxlength="5000"
                                show-word-limit :autosize="{ minRows: 3, maxRows: 8 }"
                                placeholder="请输入世界观设定"></el-input>
                            <!-- 停止生成按钮 -->
                            <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                v-if="streamStatus && requireIndex === 3"></AIStopCreate>
                            <div class="novel_info2_14 cursor_1" @click="openPopup('世界观', 3)"></div>
                            <div class="loading_text" v-if="streamStatus && requireIndex === 3">
                                <img src="../assets/image/loading.png" alt="">
                            </div>
                        </div>
                    </div>
                    <!-- 金手指 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            金手指<span>(非必填)</span>
                        </div>
                        <div class="novel_info2_3">
                            <el-input v-model="novelInfo.goldfinger" type="textarea" ref="goldfinger" :maxlength="5000"
                                show-word-limit :autosize="{ minRows: 3, maxRows: 8 }"
                                placeholder="请输入金手指设定"></el-input>
                            <!-- 停止生成按钮 -->
                            <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                v-if="streamStatus && requireIndex === 4"></AIStopCreate>
                            <div class="novel_info2_14 cursor_1" @click="openPopup('金手指', 4)"></div>
                            <div class="loading_text" v-if="streamStatus && requireIndex == 4">
                                <img src="../assets/image/loading.png" alt="">
                            </div>
                        </div>
                    </div>
                    <!-- 主线剧情 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>主线剧情
                        </div>
                        <div class="novel_info2_3">
                            <el-input v-model="novelInfo.plot" type="textarea" ref="nzxjq" :maxlength="20000"
                                show-word-limit :autosize="{ minRows: 3, maxRows: 8 }" placeholder="请输入主线剧情"></el-input>
                            <!-- 停止生成按钮 -->
                            <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                v-if="streamStatus && requireIndex === 5"></AIStopCreate>
                            <div class="novel_info2_14 cursor_1" @click="openPopup('主线剧情', 5)"></div>
                            <div class="loading_text" v-if="streamStatus && requireIndex == 5">
                                <img src="../assets/image/loading.png" alt="">
                            </div>
                        </div>
                    </div>

                    <!--  角色信息 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>角色信息
                        </div>
                        <div class="novel_info2_3">
                            <el-input v-model="novelInfo.protagonists" ref="nxsjsm" type="textarea" :maxlength="10000"
                                show-word-limit :autosize="{ minRows: 3, maxRows: 8 }"
                                placeholder="请输入角色名字、性格、外貌特征"></el-input>
                            <!-- 停止生成按钮 -->
                            <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                v-if="streamStatus && requireIndex === 1"></AIStopCreate>
                            <div class="novel_info2_14 cursor_1" @click="openPopup('角色信息', 1)"></div>
                            <div class="loading_text" v-if="streamStatus && requireIndex == 1">
                                <img src="../assets/image/loading.png" alt="">
                            </div>
                        </div>
                    </div>

                    <!-- 作品简介 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>作品简介
                        </div>
                        <div class="novel_info2_3">
                            <el-input v-model="novelInfo.introduction" ref="nxsjj" type="textarea" :maxlength="3000"
                                show-word-limit :autosize="{ minRows: 3, maxRows: 8 }" placeholder="请输入作品简介"></el-input>
                            <!-- 停止生成按钮 -->
                            <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                v-if="streamStatus && requireIndex === 2"></AIStopCreate>
                            <div class="novel_info2_14 cursor_1" @click="openPopup('作品简介', 2)"></div>
                            <div class="loading_text" v-if="streamStatus && requireIndex == 2">
                                <img src="../assets/image/loading.png" alt="">
                            </div>
                        </div>
                    </div>
                    <!-- 作品要求 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            作品要求<span>(非必填)</span>
                        </div>
                        <div class="novel_info2_3">
                            <el-input v-model="novelInfo.requirement" type="textarea" :maxlength="5000" show-word-limit
                                :autosize="{ minRows: 3, maxRows: 8 }" placeholder="请输入作品要求"></el-input>
                        </div>
                    </div>

                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_8">严禁上传任何抄袭、涉黄、涉赌、涉毒、涉政、涉黑等违规内容。一经查实，全书屏蔽整改 并取消福利，情节严重的会追究其法律责任。
                            </div>
                        </div>
                    </div>


                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info20">
                                <el-button class="novel_info2_9" :loading="loading" type="warning" @click="submit">
                                    <span v-if="isCopy">{{ loading ? '克隆中...' : '克隆小说' }}</span>
                                    <span v-else>{{ loading ? '正在修改...' : '提交修改' }}</span>
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <novelCover ref="createCover" @changeCover="changeCover" @opne="opne"></novelCover>
        <createLabel title="小说标签" ref="createLabel" @getLable="getLable" />
        <createLabel2 ref="createLabel2" @getLable="getLable2" />
        <createLabel3 title="小说题材" ref="createLabel3" @getLable="getLable3" />
        <createHelp ref="createHelp" @getRequire="getRequire" />
        <delPpopup ref="delPpopup" @confirm="confirm"></delPpopup>
    </div>
</template>

<script>

import data from '@/assets/data';
import novelCover from "@/components/novel_cover.vue" //更换封面
import createLabel from './novel_create_label.vue';
import createLabel2 from './novel_create_label2.vue';
import createLabel3 from './novel_create_label3.vue';
import createHelp from './novel_create_help.vue';
import api from '@/api/api';
import delPpopup from './del_popup.vue';
import _ from 'lodash'
import { EventBus } from '@/utils/eventBus';
// import {downloadImage} from '@/utils/utils'
export default {
    components: {
        novelCover, createLabel, createHelp, delPpopup, createLabel2, createLabel3
    },
    props: {
        successNovelId: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            ifModify: false,//表单内容是否修改状态
            novelInfo: { labels: [], style: [], length: '', recall: false },//小说信息
            oldNoveInfo: {},//保存初始化的数据
            sex: data.sex, //性别
            result: ['完整结局', '开放结局'],//小说结局
            resultText: ['选择“完整结局”,最后一章将为小说提供一个明确的结局', '选择“开放结局”,故事将保留伏笔,便于后续续写或连载'],
            resultIndex: 0, //小说结局index
            chapterText: '支持百万字小说连载:作品首次创建时支持一次性生成最多100章节，生成完成后，用户可在现有 框架下无限续写章节。',
            iconSelect: data.iconSelect, //图标
            requireIndex: null, //帮写要求 0作品名称 1角色信息 2作品简介
            novelStatus: ['连载', '完结'],
            //必填项字段,移除单选按钮这些，进行验证
            verify: ['typeName', 'labelNames', 'style', 'maxChapter', 'chaptersNumber', 'plot', 'protagonistNames', 'novelName', 'introduction'],
            options: [], //类型
            viewList: ['第一人称', '第三人称'],//写作视角集合
            lengthList: ['中长篇小说', '短篇小说'],//篇幅设定列表
            streamStatus: false, //流式请求
            streamIndex: 0, //流式请求下标
            streamLast: false, //流式最后一条
            debounceTimer: null, //防抖定时器
            typingTimer: null, // 打字效果定时器
            maxChapterLen: 200,
            chaptersNumberLen: 50,//长篇小说首次生成章节200
            shortStoryLen: 50,//短篇小说首次生成章节50
            refType: null,//ai生成的滚动
            isCopy: false,
            loading: false,//加载
        }
    },
    created() {
        this.getUserLoginState(false)
        setTimeout(() => {
            this.getNovelinfo()
        }, 200);
    },
    beforeDestroy() {
        this.clearTime()
    },
    methods: {
        downloadImg() {
            // downloadImage(this.novelInfo.img, this.novelInfo.name+'.png')
        },
        copy(status) {
            this.isCopy = status
            console.log('copys=', this.isCopy);
        },
        //返回true代表不能编辑，false代表可以编辑
        isEditor() {
            //如果是克隆就代表都可以编辑
            if (this.isCopy) {
                return false
            }
            if (!this.novelInfo.hasOwnProperty('thereAnOutline')) return false
            return this.novelInfo.thereAnOutline
        },
        //获取小说类型
        getStyle() {
            api.getParameter('pcxscs', 'style').then((res) => {
                if (res.code == 200) {
                    res.data[0].children.forEach(item => {
                        let children = item.placeholder.split(',');
                        let childrenArray = children.map(child => ({ value: child, label: child }));
                        this.options.push({
                            value: item.paramName,
                            label: item.paramName,
                            children: childrenArray
                        });
                    });
                }
            })
        },
        toNovellist() {
            if (!this.editorIsEqual()) {
                this.$refs.delPpopup.openPrompt(3)
            } else {
                this.$emit('toNovellist')
            }
        },
        //打开封面
        openCover() {
            this.$refs.createCover.open(this.novelInfo.id)
        },
        //切换封面
        changeCover(item) {
            api.modifyCover({
                novelId: this.novelInfo.id,
                img: item
            }).then((res) => {
                if (res.code == 200) {
                    this.novelInfo.img = item
                    this.$message.success('修改封面成功！')
                }
            })
        },
        //获取小说信息
        getNovelinfo() {
            api.novelDetail(this.successNovelId).then((res) => {
                if (res.code == 200) {
                    this.novelInfo = res.data
                    // res.data.novelSex = '男生,女生'
                    // res.data.novelSex = '男生'
                    // res.data.novelSex = '女生'
                    // res.data.novelSex = null
                    // res.data.novelSex = undefined
                    // res.data.novelSex = ''
                    // res.data.novelSex = '男'
                    // res.data.novelSex = '女'
                    // res.data.novelSex = '无性别偏向'
                    if (Array.isArray(res.data.novelSex) || !res.data.novelSex || res.data.novelSex == null || res.data.novelSex == undefined) {
                        this.novelInfo.novelSex = '无性别偏向'
                    } else {
                        if (res.data.novelSex.includes(',')) {
                            this.novelInfo.novelSex = '无性别偏向'
                        }
                        if (res.data.novelSex.includes('男')) {
                            this.novelInfo.novelSex = '男频'
                        } else if (res.data.novelSex.includes('女')) {
                            this.novelInfo.novelSex = '女频'
                        }
                        this.novelInfo.novelSex = res.data.novelSex
                    }
                    this.novelInfo.labels = res.data.labels.split(',')
                    this.novelInfo.style = res.data.style ? res.data.style.split(',') : []
                    if (res.data.length.includes('长')) {
                        this.novelInfo['length'] = '中长篇小说'
                    } else if (res.data.length.includes('短')) {
                        this.novelInfo['length'] = '短篇小说'
                    } else {
                        this.novelInfo['length'] = res.data['length'] || '中长篇小说'
                    }
                    this.novelInfo.world = res.data.world || '无'
                    this.novelInfo.plot = res.data.plot || '无'
                    this.novelInfo.goldfinger = res.data.goldfinger || '无'
                    this.novelInfo.protagonists = res.data.protagonists || '无'
                    this.novelInfo.introduction = res.data.introduction || '无'
                    this.novelInfo.requirement = res.data.requirement || '无'
                    //如果当前用户不是专属会员，长记忆就进行关闭，哪怕当前小说信息返回过来的长记忆是属于开启状态
                    if (!this.zsVip()) {
                        this.novelInfo.recall = false
                    }
                    this.oldNoveInfo = _.cloneDeep(this.novelInfo);
                }
            })

        },
        //检测用户是否已经编辑了
        editorIsEqual() {
            console.log(this.novelInfo)
            return _.isEqual(this.novelInfo, this.oldNoveInfo)
        },
        //小说结局类型
        // getResult(i) {
        //     this.resultIndex = i
        //     this.novelInfo.done = this.resultIndex == 0 ? 'complete' : 'open'
        // },
        // 核心受众
        getSex(value) {
            if (this.novelInfo.novelSex === value) return
            this.novelInfo.novelSex = value
        },
        //写作视角切换
        getview(name) {
            if (this.novelInfo.view === name) return
            this.novelInfo.view = name
        },
        //篇幅设定切换
        getLength(value) {
            if (this.novelInfo.length === value) return
            this.novelInfo.length = value
        },
        // 作品类型
        getTypeName(value) {
            //如果有大纲就不能进行编辑
            if (this.novelInfo.thereAnOutline) return
            this.novelInfo.typeName = value[1]
        },
        //帮写提示
        openPopup(title, i) {
            if (!this.validateForm(i)) {
                return;
            }
            this.requireIndex = i
            this.$refs.createHelp.open(title);
        },
        //销毁定时器
        clearTime() {
            clearTimeout(this.debounceTimer);
            clearInterval(this.typingTimer);
            this.streamStatus = false
            this.streamLast = false
            this.streamIndex = 0
            this.refType = null
        },
        // 封装验证逻辑到独立函数
        validateForm(i) {
            const validationRules = [
                {
                    condition: () => this.novelInfo.typeName === '',
                    message: '请选择小说题材！'
                },
                {
                    condition: () => this.novelInfo.labels.length === 0,
                    message: '请选择小说标签！'
                },
                {
                    condition: () => this.novelInfo.style.length === 0,
                    message: '请选择文笔风格！'
                },
                {
                    condition: () => [1, 2, 3, 4, 5].includes(i) && this.novelInfo.length.includes('长篇') && !Number(this.novelInfo.maxChapter),
                    message: '请输入总章节数！'
                },
                {
                    condition: () => {
                        if ([1, 2, 3, 4, 5].includes(i) && this.novelInfo.length.includes('长篇') && Number(this.novelInfo.maxChapter) && Number(this.novelInfo.maxChapter) > this.maxChapterLen) {
                            this.novelInfo.maxChapter = this.maxChapterLen
                            return true
                        }
                        return false
                    },
                    message: `总章节数超过${this.maxChapterLen}，已同步短篇最高章节数`
                },
                {
                    condition: () => [1, 2, 3, 4, 5].includes(i) && !Number(this.novelInfo.chaptersNumber),
                    message: '请首次生成章节！'
                },
                {
                    condition: () => {
                        if ([1, 2, 3, 4, 5].includes(i) && this.novelInfo.length.includes('短篇') && this.novelInfo.chaptersNumber && Number(this.novelInfo.chaptersNumber) > this.shortStoryLen) {
                            this.novelInfo.chaptersNumber = this.shortStoryLen
                            return true
                        }
                        return false
                    },
                    message: `短篇生成章节超过${this.shortStoryLen}，已同步短篇最高章节数`
                },
                {
                    condition: () => {
                        if ([1, 2, 3, 4, 5].includes(i) && this.novelInfo.length.includes('长篇') && this.novelInfo.chaptersNumber && Number(this.novelInfo.chaptersNumber) > Number(this.chaptersNumberLen)) {
                            this.novelInfo.chaptersNumber = this.chaptersNumberLen
                            return true
                        }
                        return false
                    },
                    message: `中篇首次生成章节超过${this.chaptersNumberLen}，已同步首次生成最高章节数`
                },
                {
                    condition: () => {
                        if ([1, 2, 3, 4, 5].includes(i) && this.novelInfo.length.includes('长篇') && Number(this.novelInfo.chaptersNumber) > Number(this.novelInfo.maxChapter)) {
                            this.novelInfo.maxChapter = this.novelInfo.chaptersNumber
                            return true
                        }
                        return false
                    },
                    message: `中篇首次生成章节数不能超过总章节数，已同步首次生成最高章节数`
                },
                {
                    //主线剧情
                    condition: () => [0, 1, 2, 6].includes(i) && !this.novelInfo.plot.trim(),
                    message: '请填写主线剧情'
                },
                {
                    //角色信息
                    condition: () => [0, 6].includes(i) && !this.novelInfo.protagonists.trim(),
                    message: '请填写角色信息'
                },
                {
                    //作品名称
                    condition: () => i == 2 && !this.novelInfo.name.trim(),
                    message: '请填写作品名称'
                },
                {
                    condition: () => this.streamStatus,
                    message: '请等待AI生成结束！'
                }
            ];

            for (const rule of validationRules) {
                if (rule.condition()) {
                    this.$message({
                        message: rule.message,
                        type: 'warning'
                    });
                    return false;
                }
            }
            return true;
        },
        //帮写提示词
        getRequire(item) {
            const baseParams = {
                ...this.novelInfo,
                menAndWomen: this.novelInfo.novelSex,//性别
                style: this.novelInfo.typeName,//作品类型
                label: this.novelInfo.labels.join(','),//作品标签
                wstyle: this.novelInfo.style.join(','),//文笔风格
                name: this.novelInfo.name,
                novelName: this.novelInfo.name,
                protagonists: this.novelInfo.protagonistNames,
                // view: this.novelInfo.view,//写作视角
                // length: this.novelInfo.length,//篇幅设定
                maxChapter: this.novelInfo.length.includes('短篇') ? this.novelInfo.chaptersNumber : this.novelInfo.maxChapter,//总章节数
                // chaptersNumber: this.novelInfo.chaptersNumber,//首次生成章节
                platform: 1,//平台
                requirement: item, //弹窗填写的内容
                novelId: this.successNovelId,//小说id
            };
            //帮写要求 0作品名称 1角色信息 2作品简介 3世界观 4金手指 5主线剧情
            if (this.requireIndex == 0) {
                this.novelInfo.novelName = ''
                this.getStream('nxszpm', this.novelInfo.length.includes('短') ? 'short_name' : 'medium_name', baseParams);
            } else if (this.requireIndex == 1) {
                this.novelInfo.protagonists = ''
                this.getStream('nxsjsm', this.novelInfo.length.includes('短') ? 'short_role' : 'medium_role', baseParams);
            } else if (this.requireIndex == 2) {
                this.novelInfo.introduction = ''
                this.getStream('nxsjj', this.novelInfo.length.includes('短') ? 'short_introduction' : 'medium_introduction', baseParams);
            } else if (this.requireIndex == 3) {
                this.novelInfo.world = ''
                this.getStream('world', this.novelInfo.length.includes('短') ? 'short_world' : 'medium_world', baseParams);
            } else if (this.requireIndex == 4) {
                this.novelInfo.goldfinger = ''
                this.getStream('goldfinger', this.novelInfo.length.includes('短') ? 'short_goldfinger' : 'medium_goldfinger', baseParams);
            } else if (this.requireIndex == 5) {
                this.novelInfo.plot = ''
                this.getStream('nzxjq', this.novelInfo.length.includes('短') ? 'short_plot' : 'medium_plot', baseParams);
            } else if (this.requireIndex == 6) {
                this.novelInfo.outlineSetting = ''
                this.getStream('outline_setting', baseParams);
            }
        },
        getStream(type, aiType, params) {
            this.AIWrite({
                length: '中',
                haveId: false,
                type: aiType,
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    this.refType = type
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                }
            })
            // api.novelHelpWrite(aiType, params).then((res) => {
            //     if (res.code === 200) {
            //         this.streamStatus = true
            //         this.refType = type
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     }else{
            //         this.$message.warning(res.msg)
            //     }
            // })
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            let combinedText = '';
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item;
                                }
                            });
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0;
                                    this.streamLast = true
                                }
                                if (this.streamLast) {
                                    this.streamStatus = false;
                                    this.streamLast = false;
                                    // sessionStorage.removeItem('streamStatus');
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    this.$message.success('AI生成完成！');
                                } else {
                                    this.getStreamContent(id);
                                }
                            });
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTime()
                    }
                }).catch(() => {
                    this.refType = null
                });
            }, 500);
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0;
            if (this.typingTimer) {
                clearInterval(this.typingTimer);
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    if (this.requireIndex == 0) {
                        this.novelInfo.name += text[index]
                    } else if (this.requireIndex == 1) {
                        this.novelInfo.protagonists += text[index]
                    } else if (this.requireIndex == 2) {
                        this.novelInfo.introduction += text[index]
                    } else if (this.requireIndex == 3) {
                        this.novelInfo.world += text[index]
                    } else if (this.requireIndex == 4) {
                        this.novelInfo.goldfinger += text[index]
                    } else if (this.requireIndex == 5) {
                        this.novelInfo.plot += text[index]
                    } else if (this.requireIndex == 6) {
                        this.novelInfo.outlineSetting += text[index]
                    }
                    index++;
                    this.$nextTick(() => {
                        const textarea = this.$refs[this.refType].$el.querySelector('textarea');
                        if (textarea) {
                            // 滚动到底部
                            textarea.scrollTop = textarea.scrollHeight;
                        }
                    });
                } else {
                    clearInterval(this.typingTimer);
                    if (callback) {
                        callback();
                    }
                }
            }, 20);
        },
        // 选择标签
        openLabel() {
            this.$refs.createLabel.openLable(this.novelInfo.labels);
        },
        // 选择文笔风格标签
        openLabel2() {
            this.$refs.createLabel2.openLable(this.novelInfo.style);
        },
        // 选择文笔风格标签
        openLabel3() {
            this.$refs.createLabel3.openLable(this.novelInfo.typeName);
        },
        // 获取标签
        getLable(i) {
            this.novelInfo.labels = i
        },
        // 获取文笔风格
        getLable2(i) {
            this.novelInfo.style = i
        },
        // 获取作品类型
        getLable3(i) {
            this.novelInfo.typeName = i
        },
        // 删除标签
        delLabel(i, type) {
            this.$confirm('是否删除标签？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (type === '标签') {
                    this.novelInfo.labels.splice(i, 1)
                } else if (type === '风格') {
                    this.novelInfo.style.splice(i, 1)
                }
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //小说状态
        getStatus(i) {
            this.novelInfo.status = i
        },
        submit() {
            if (this.streamStatus) {
                this.$message({
                    message: '请等待AI生成结束！',
                    type: 'warning'
                });
                return
            }
            let item = null
            item = this.novelEditor()
            //公共的验证
            // console.log('item=', item);
            if (!item.novelName) {
                this.$message.warning(`请输入作品名称`);
                return
            }
            if (!item.typeName) {
                this.$message.warning(`请选择小说题材`);
                return
            }
            if (!item.labelNames) {
                this.$message.warning(`请选择小说标签`);
                return
            }
            if (!item.style) {
                this.$message.warning(`请选择文笔风格`);
                return
            }
            if (!item.maxChapter && item.length.includes('长篇')) {
                this.$message.warning(`请输入总章节数`);
                return
            }
            if (!item.chaptersNumber) {
                this.$message.warning(item.length.includes('长篇') ? `请输入首次生成章节数` : `请输入生成章节数`);
                return
            }
            // 没有大纲 或者 克隆的情况才会去验证
            if (item.length.includes('长篇') && Number(item.maxChapter) > this.maxChapterLen) {
                this.$message.warning(`总章节数超过${this.maxChapterLen}，已同步最高章节数`);
                this.novelInfo.maxChapter = this.maxChapterLen
                return
            }
            if (item.length.includes('短篇') && Number(item.chaptersNumber) > this.shortStoryLen) {
                this.$message.warning(`短篇生成章节超过${this.shortStoryLen}，已同步短篇最高章节数`);
                this.novelInfo.chaptersNumber = this.shortStoryLen
                return
            }
            if (item.length.includes('长篇') && Number(item.chaptersNumber) > Number(this.chaptersNumberLen)) {
                this.$message.warning(`中篇首次生成章节超过${this.chaptersNumberLen}，已同步首次生成最高章节数`);
                this.novelInfo.chaptersNumber = this.chaptersNumberLen
                return
            }
            if (item.length.includes('长篇') && Number(item.chaptersNumber) > Number(item.maxChapter)) {
                this.$message.warning(`中篇首次生成章节数不能超过总章节数，已同步首次生成最高章节数`);
                this.novelInfo.maxChapter = this.novelInfo.chaptersNumber
                return
            }
            if (!item.plot) {
                this.$message.warning(`请输入主线剧情`);
                return
            }
            if (!item.protagonistNames) {
                this.$message.warning(`请输入角色信息`);
                return
            }
            // if (item.length.includes('长篇') && !item.outlineSetting) {
            //     this.$message.warning(`请输入大纲初步设定`);
            //     return
            // }
            if (!item.introduction) {
                this.$message.warning(`请输入作品简介`);
                return
            }
            if (item.length.includes('短篇')) {
                item.maxChapter = item.chaptersNumber
            }
            this.loading = true
            // console.log('item=', item);
            if (this.isCopy) {
                api.createNovel(item).then((res) => {
                    if (res.code === 200) {
                        this.$message.success('克隆成功')
                        this.$emit('createSuccess', res.data)
                    } else {
                        this.$message.warning(res.msg)
                    }
                }).finally(() => {
                    this.loading = false
                })
            } else {
                api.modifyNovel(item).then((res) => {
                    if (res.code == 200) {
                        this.$message.success('作品修改成功')
                        this.oldNoveInfo = _.cloneDeep(this.novelInfo);
                    } else {
                        this.$message.warning(res.msg)
                    }
                }).finally(() => {
                    this.loading = false
                })
            }


        },
        //小说信息编辑，带id
        novelEditor() {
            let data = {
                sex: this.novelInfo.novelSex,//核心受众
                typeName: this.novelInfo.typeName,//作品类型
                labelNames: this.novelInfo.labels.join(','),//作品标签
                style: this.novelInfo.style.join(','),//文笔风格
                view: this.novelInfo.view,//写作视角
                recall: this.novelInfo.recall,//长记忆功能
                length: this.novelInfo.length,//篇幅设定
                maxChapter: this.novelInfo.maxChapter,//总章节数
                chaptersNumber: this.novelInfo.chaptersNumber,//首次生成章节
                world: this.novelInfo.world,//世界观
                goldfinger: this.novelInfo.goldfinger,//金手指
                plot: this.novelInfo.plot,//主线剧情
                protagonistNames: this.novelInfo.protagonists,// 角色信息
                outlineSetting: this.novelInfo.outlineSetting || '无',//大纲初步设定
                novelName: this.novelInfo.name,//作品名称
                introduction: this.novelInfo.introduction,//作品简介
                requirement: this.novelInfo.requirement,//作品要求
            }
            //如果不是克隆，就需要id
            if (!this.isCopy) {
                data.novelId = this.novelInfo.id //小说id
                data.done = this.novelInfo.done //小说结局
                data.status = this.novelInfo.status//小说状态
            }
            return data
        },
        confirm() {
            // this.$refs.createCover.delConfirm()
            this.$emit('toNovellist')
        },
        opne() {
            this.$refs.delPopup.openPrompt(0)
        },
        //停止生成
        stop(name, index) {
            this.$message.success('AI已停止生成！')
            //刷新用户信息-基础会员字符刷新
            this.getUserInfo()
            this.clearTime()
        },
        cjyChange(e) {
            // if(!this.isCopy){
            //     this.novelInfo.recall = false
            //     return
            // }
            if (!this.zsVip()) {
                this.novelInfo.recall = false
                this.$confirm('超长记忆功能，仅专业会员特享，立即去开通？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    EventBus.$emit('openVip')
                }).catch(() => {

                });
                return
            }
        }

    }
}
</script>

<style>
.novel_info2_1 .el-textarea .el-input__count,
.novel_info2_1 .el-input .el-input__count .el-input__count-inner {
    background: transparent;
}

#novel_info {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 10px;
    padding: 35px 30px;
}

.novel_info {
    width: 100%;
    height: calc(100% - 45px);
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.novel_info1 {
    display: flex;
    flex-flow: column;
    align-items: center;
}

.novel_info1_1 {
    width: 200px;
    height: 267px;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 10px;
}

.novel_info1_1 img {
    width: 100%;
    object-fit: cover;
}

.novel_info1_2 {
    width: 85px;
    height: 25px;
    line-height: 25px;
    /* background: url('../assets/image/icon_create5.png') no-repeat; */
    background-size: 21px 21px;
    background-position: left center;
    font-size: 15px;
    color: #333333;
    display: flex;
}

.novel_info1_2 span:hover {
    /* background: url('../assets/image/icon_create6.png') no-repeat; */
    background-size: 21px 21px;
    background-position: left center;
    color: #FF6603;
}

.novel_info2 {
    width: 100%;
    padding-right: 60px;
    height: 100%;
    margin-left: 20px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.novel_info2_15 {
    width: 800px;
}

.novel_info2_1 {
    display: flex;
    margin-bottom: 15px;
}

.novel_info2_2 {
    width: 150px;
    font-size: 16px;
    color: #0B0B0B;
    text-align: end;
    margin-right: 20px;
    flex-shrink: 0;
}

.novel_info2_2 span {
    color: #FF3030;
}

.novel_info2_3 {
    flex: 1;
    font-size: 16px;
    color: #0B0B0B;
    display: flex;
    align-items: center;
    position: relative;
}

.novel_info2_4 {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #111111;
    margin-right: 10px;
    cursor: pointer;
}

.novel_info2_4 img {
    width: 19px;
    height: 19px;
    margin-right: 8px;
}

.novel_info3 {
    padding-left: 85px;
    font-size: 13px;
    color: #888888;
    margin-bottom: 15px;
}

.el-input--suffix .el-input__inner::-webkit-input-placeholder,
.novel_info2_3 .el-input__inner::-webkit-input-placeholder,
.novel_info2_3 .el-textarea__inner::-webkit-input-placeholder {
    color: #777777;
    /* 提示字颜色 */
    font-weight: 400;
    font-size: 15px !important;
}

.novel_info2_3 .el-input__inner,
.novel_info2_3 .el-textarea__inner {
    width: 695px;
    background-color: #F6F6F6;
    resize: none;
    font-size: 15px;
}

.novel_info2_5 {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.novel_info2_6 {
    background: var(--tech-btn-Lightblue);
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 8px 8px;
    font-size: 15px;
    color: var(--tech-primary);
    margin-right: 10px;
    margin-bottom: 10px;
}

.novel_info2_6 img {
    width: 18px;
    height: 18px;
    margin-left: 5px;
}

.novel_info2_7 {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: var(--tech-primary);
    padding: 5px 0;
    margin-bottom: 10px;
}

.novel_info2_7 img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
}

.novel_info2_8 {
    width: 695px;
    padding: 13px;
    background-color: #FFEBEB;
    border-radius: 4px;
    font-size: 13px;
    color: #FF3030;
}

.novel_info20 {
    display: flex;
    justify-content: flex-end;
    width: 695px;
    border-radius: 4px;
}

.novel_info2_9 {
    width: 125px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    color: #FFF;
    margin-top: 10px;
}

.novel_info2_9>span {
    font-size: 15px;
}

.novel_info2_11 {
    width: 100%;
    display: flex;
    justify-content: end;
    border: 1px solid red;
}

.novel_info2_12 {
    margin-left: 85px;
}

.novel_info2_13 {
    padding-left: 85px;
    font-size: 13px;
    color: #548AFF;
    margin-top: 10px;
    margin-bottom: 20px;
}

.novel_info2_14 {
    position: absolute;
    right: -60px;
    top: 0;
    width: 58px;
    height: 25px;
    background: url('../assets/image/icon_create1.png') no-repeat;
    background-size: 100% 100%;
}

.novel_info2_14:hover {
    background: url('../assets/image/icon_create2.png') no-repeat;
    background-size: 100% 100%;
}

.noEditor {
    filter: grayscale(100%);
    opacity: 0.7;
    /* 可选视觉提示 */
    cursor: not-allowed !important;
    position: relative;

}

.noEditor .noClick {
    pointer-events: none;
}

.loading_text {
    position: absolute;
    right: -100px;
    top: 3px;
    width: 19px;
    height: 19px;
}

.loading_text img {
    width: 100%;
    height: 100%;
    animation: rotate 1s linear infinite;
}

/* 定义旋转动画 */
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>